module.exports = __webpack_public_path__ + "static/img/pin-trap-scheduled-mandatory-irregular.a02129e.svg";